var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leo-operator-assistant" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: "Leo SOC助手",
            visible: _vm.drawerOpen,
            size: "420px",
            direction: "rtl",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.drawerOpen = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "assistant-mode-tabs" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: _vm.mode === "manual" ? "primary" : "default"
                  },
                  on: {
                    click: function($event) {
                      _vm.mode = "manual"
                    }
                  }
                },
                [_vm._v("问说明书")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: _vm.mode === "guide" ? "primary" : "default"
                  },
                  on: {
                    click: function($event) {
                      _vm.mode = "guide"
                    }
                  }
                },
                [_vm._v("智能引导")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.mode === "guide"
            ? _c("div", [_c("soc-smart-guide-panel")], 1)
            : _c(
                "div",
                [
                  _c("p", { staticClass: "muted assistant-hint" }, [
                    _vm._v(
                      "\n      问后台操作、训练 SOP、何时找工程。已感知当前页面，快捷问法仅显示本页相关。\n    "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.pagePreface
                    ? _c("p", { staticClass: "assistant-page-preface" }, [
                        _vm._v(_vm._s(_vm.pagePreface))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.topicScope
                    ? _c(
                        "el-tag",
                        {
                          staticClass: "assistant-scope-tag",
                          attrs: { size: "mini", type: _vm.topicScopeTagType }
                        },
                        [_vm._v(_vm._s(_vm.topicScopeLabel))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.clarifyOptions.length
                    ? _c(
                        "div",
                        { staticClass: "assistant-clarify" },
                        [
                          _c("p", { staticClass: "assistant-clarify-prompt" }, [
                            _vm._v(_vm._s(_vm.clarifyPrompt))
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.clarifyOptions, function(opt, idx) {
                            return _c(
                              "el-button",
                              {
                                key: idx,
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  plain: ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.askClarifyOption(opt)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(opt.label))]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.quickTopics.length
                    ? _c(
                        "div",
                        { staticClass: "assistant-topics" },
                        _vm._l(_vm.quickTopics, function(t) {
                          return _c(
                            "el-button",
                            {
                              key: t.id,
                              attrs: {
                                size: "mini",
                                plain: "",
                                loading:
                                  _vm.loading && _vm.question === t.question
                              },
                              on: {
                                click: function($event) {
                                  return _vm.askQuick(t.question)
                                }
                              }
                            },
                            [_vm._v(_vm._s(t.labelZh))]
                          )
                        }),
                        1
                      )
                    : _vm.topicScope === "empty"
                    ? _c("p", { staticClass: "assistant-empty-topics muted" }, [
                        _vm._v(
                          "\n      本页暂无快捷问法，请直接在下方输入本页相关问题。\n    "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "输入问题，例如：这页设备列表怎么搜 IMIE？"
                    },
                    model: {
                      value: _vm.question,
                      callback: function($$v) {
                        _vm.question = $$v
                      },
                      expression: "question"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "assistant-actions" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            loading: _vm.loading
                          },
                          on: { click: _vm.ask }
                        },
                        [_vm._v("提问")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            size: "small",
                            plain: "",
                            disabled: !_vm.answer || _vm.loading
                          },
                          on: { click: _vm.onWrongAnswer }
                        },
                        [_vm._v("回答不对")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.answer
                    ? _c("div", { staticClass: "assistant-answer" }, [
                        _c(
                          "div",
                          { staticClass: "assistant-answer-title" },
                          [
                            _vm._v("\n        回答\n        "),
                            _vm.answerLayerZh
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "assistant-layer-tag",
                                    attrs: {
                                      size: "mini",
                                      type: _vm.answerLayerTagType
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.answerLayerZh))]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("pre", { staticClass: "assistant-answer-body" }, [
                          _vm._v(_vm._s(_vm.answer))
                        ]),
                        _vm._v(" "),
                        _vm.disclaimer
                          ? _c("p", { staticClass: "muted" }, [
                              _vm._v(_vm._s(_vm.disclaimer))
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-477408b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-477408b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeoKnowledge/LeoTrainingOperatorAssistant.vue
// module id = null
// module chunks = 